import { render, staticRenderFns } from "./ApplySubscriptionButton.vue?vue&type=template&id=2961a0c1&scoped=true&"
import script from "./ApplySubscriptionButton.vue?vue&type=script&lang=ts&"
export * from "./ApplySubscriptionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2961a0c1",
  null
  
)

export default component.exports